import { getPlaceById } from '@/services/places';

export const usePlace = () => {
  const getPlace = async (placeId: string) => {
    try {
      const res = await getPlaceById(placeId);
      return res.data;
    } catch (err) {
      console.error(err);
    }
  };

  return { getPlace };
};
